var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 18.014 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.761 16.483l-3.34-3.313a8.1 8.1 0 10-1.251 1.251l3.313 3.313a.894.894 0 101.278-1.251zm-9.64-2.062a6.3 6.3 0 116.3-6.3 6.3 6.3 0 01-6.3 6.3z",
    fill: "#3b52ff"
  })));
}

export default SvgSearchBlue;